import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["subject", "objectTypeDefinition", "isDealSplitsEnabled", "onNavigateToRecordPage", "recordHref", "titleProperty", "getIsUngated"];
import { Button } from 'foundations-components/transitional/components/Button';
import { createLinkFromObjectAndTypeDefinition } from '../utils/utils';
import { getProperty } from 'customer-data-objects/objects/ObjectAccessors';
import { DEAL_TYPE_ID, LEAD_TYPE_ID, TASK_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import DealSplitIcon from './DealSplitIcon';
import { TitleProperty } from './TitleProperty';
import { Flex } from 'foundations-components/components/Flex';
import { gate } from 'hub-http/gates';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const getIcons = (subject, objectTypeDefinition, isDealSplitsEnabled) => {
  const icons = [];
  if (objectTypeDefinition.objectTypeId === DEAL_TYPE_ID) {
    const numAssociatedDealSplits = getProperty(subject, 'hs_num_associated_deal_splits');
    const hasDealSplit = isDealSplitsEnabled && numAssociatedDealSplits && +numAssociatedDealSplits > 1;
    if (hasDealSplit) {
      icons.push( /*#__PURE__*/_jsx(DealSplitIcon, {}, "deal-split-icon"));
    }
  }
  return icons;
};
const Title = _ref => {
  let {
      subject,
      objectTypeDefinition,
      isDealSplitsEnabled,
      onNavigateToRecordPage,
      recordHref: recordHrefProp,
      titleProperty,
      getIsUngated
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const recordHref = recordHrefProp || createLinkFromObjectAndTypeDefinition(subject, objectTypeDefinition, getIsUngated);
  const icons = getIcons(subject, objectTypeDefinition, isDealSplitsEnabled);
  const sendPreviewMessageForLeads = useSendCrmMessageTopic('PREVIEW_OBJECT');
  const isTaskWithoutSalesWorkspaceTasksUngated = objectTypeDefinition.objectTypeId === TASK_TYPE_ID && getIsUngated && !getIsUngated(gate('SalesWorkspace:Tasks'));
  if (isTaskWithoutSalesWorkspaceTasksUngated) {
    // hide link in this situation
    return /*#__PURE__*/_jsx("div", Object.assign({}, props, {
      children: /*#__PURE__*/_jsx(Flex, {
        as: "span",
        alignItems: "baseline",
        children: /*#__PURE__*/_jsx(TitleProperty, {
          subject: subject,
          objectTypeDefinition: objectTypeDefinition,
          titleProperty: titleProperty
        })
      })
    }));
  }
  if (objectTypeDefinition.objectTypeId === LEAD_TYPE_ID) {
    return /*#__PURE__*/_jsx("div", Object.assign({}, props, {
      children: /*#__PURE__*/_jsx(Button, {
        "data-test-id": "cdbc-title",
        use: "link",
        onClick: () => {
          sendPreviewMessageForLeads({
            objectTypeId: objectTypeDefinition.objectTypeId,
            objectId: `${subject.objectId}`
          });
        },
        children: /*#__PURE__*/_jsxs(Flex, {
          as: "span",
          alignItems: "baseline",
          children: [/*#__PURE__*/_jsx(TitleProperty, {
            subject: subject,
            objectTypeDefinition: objectTypeDefinition,
            titleProperty: titleProperty
          }), icons]
        })
      })
    }));
  }
  return /*#__PURE__*/_jsx("div", Object.assign({}, props, {
    children: /*#__PURE__*/_jsx(Button, {
      href: recordHref,
      "data-test-id": "cdbc-title",
      use: "link",
      onClick: evt => {
        if (recordHref) {
          // prevents the preview sidebar from opening when navigating to the record page
          evt.stopPropagation();
          if (onNavigateToRecordPage) {
            onNavigateToRecordPage();
          }
        }
      },
      children: /*#__PURE__*/_jsxs(Flex, {
        as: "span",
        alignItems: "baseline",
        children: [/*#__PURE__*/_jsx(TitleProperty, {
          subject: subject,
          objectTypeDefinition: objectTypeDefinition,
          titleProperty: titleProperty
        }), icons]
      })
    })
  }));
};
export default Title;